<div
  class="content"
  [ngStyle]="{
    marginBottom: config.isMobileDevice ? '50px' : '0',
    minHeight: config.isMobileDevice ? '100vh' : '100%'
  }"
>
  <div class="container">
    <ng-container *ngIf="message$ | async as message">
      <bca-notification
        [message]="message"
        [currentRoute]="currentRoute$ | async"
        (close)="onClose($event)"
      >
      </bca-notification>
    </ng-container>
    <router-outlet></router-outlet>
  </div>
</div>
